import { Button, DatePicker, Modal } from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import { differenceInCalendarDays, format } from "date-fns";
import { Dayjs } from "dayjs";
import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { api } from "../../config";
import { AuthenticationState } from "../../interfaces/users";
import { downloadCsv } from "./MassExportModal";

interface ChecklistSalesExportModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ChecklistSalesExportModal = ({
  isOpen,
  onClose,
}: ChecklistSalesExportModalProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const { RangePicker } = DatePicker;
  const [start, setStart] = useState<Dayjs | null>();
  const [end, setEnd] = useState<Dayjs | null>();
  const [loading, setLoading] = useState(false);

  const clearDates = () => {
    setStart(null);
    setEnd(null);
  };

  const handleClose = () => {
    clearDates();
    onClose();
  };

  const isInvalidRange = (startDate: Dayjs, endDate: Dayjs) => {
    return differenceInCalendarDays(endDate.toDate(), startDate.toDate()) > 31;
  };

  const handleGenerate = async () => {
    if (!start || !end) return toast.error("Selecione o período corretamente");

    if (isInvalidRange(start, end)) {
      return toast.error("O período máximo para exportação é de 31 dias");
    }

    try {
      setLoading(true);
      const data = await api(token).get(
        `tickets/checklist-coupon-sales-report?start=${format(
          start.toDate(),
          "yyyy-MM-dd"
        )}&end=${format(end.toDate(), "yyyy-MM-dd")}`
      );

      downloadCsv(data, "exportar-vendas.csv");
      handleClose();
    } catch (error) {
      toast.error("Ocorreu um erro ao gerar o relatório");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      onCancel={handleClose}
      footer={() => (
        <Button
          loading={loading}
          onClick={handleGenerate}
          variant="solid"
          color="primary"
        >
          Gerar
        </Button>
      )}
    >
      <p>Período:</p>
      <RangePicker
        className="w-full"
        locale={locale}
        value={[start, end]}
        format="DD-MM-YYYY"
        onChange={(dates) => {
          if (!dates?.length || !dates[0] || !dates[1]) {
            clearDates();
            return;
          }

          if (isInvalidRange(dates[0], dates[1])) {
            clearDates();
            toast.error("O período máximo para exportação é de 31 dias");
            return;
          }

          setStart(dates[0]);
          setEnd(dates[1]);
        }}
      />
    </Modal>
  );
};
